import WebSocketManager from '../../websocket/WebSocketManager';
import { login, logoutUser } from '../slices/authSlice';

export const websocketMiddleware = () => (next) => (action) => {
  if (login.fulfilled.match(action)) {
    const { access_token, refresh_token } = action.payload;
    WebSocketManager.connect(access_token, refresh_token);
  } else if (logoutUser.fulfilled.match(action)) {
    WebSocketManager.disconnect();
  }

  return next(action);
};
